






























































































































































































import { Mixins, Component, Watch, Prop, Emit } from "vue-property-decorator";
import { ReceptionDispInfo } from "../../../domain/workflow";
import { ReceptionEditor, WorkflowRouteEditorModel } from "../../../domain/workflow/editor";
import { ReceptionDetail, ReceptionApplicant, ReceptionRecipient, ReceptionContact, ReceptionDelivery, Reception, ReceptionPatient, ReceptionComment, } from "../../../domain/workflow/reception";
import { ReceptionInputSection, ReceptionDeliveryKind, ReceptionTypeItem } from "../../../domain/workflow/items";
import { ProgressConditionKinds, ReceptionEditKinds, ReceptionCommentUnitKinds, ReceptionCommentKinds, ReceptionCommentSortItemKinds, } from "../../../domain/workflow/kinds";
import { HisInformation } from "../../../domain/his";
import { InformationKinds, HisItemParameter } from "../../../domain/his/behavior";

import { Table } from "../../../domain/system/table";

import { FormatValidatableMixin } from "../../format/mixins";
import { ModelEditableMixin } from "../../system/mixins";

import ProjectTeamListSelectorDialog from "../../projectTeam/dialogs/ProjectTeamListSelectorDialog.vue";
import DepartmentListSelectorDialog from "../../department/dialogs/DepartmentListSelectorDialog.vue";
import HisInfoListSelectDialog from "../../his/dialogs/HisInfoListSelectDialog.vue";
import CommentDialog from "../dialogs/CommentDialog.vue";
import HospitalizationHistorySelectorDialog from "../dialogs/HospitalizationHistorySelectorDialog.vue"; // 依頼詳細編集ダイアログでエラーとなったため個別でimportしている
import VisitHistorySelectorDialog from "../dialogs/VisitHistorySelectorDialog.vue"; // 依頼詳細編集ダイアログでエラーとなったため個別でimportしている
import RoutePatternSelectorDialog from "../dialogs/RoutePatternSelectorDialog.vue"; // 依頼詳細編集ダイアログ表示時にコンソールにエラーがでるため個別でimportしている

import ReceptionApplicantEditor from "./controls/ReceptionApplicantEditor.vue";
import ReceptionContactEditor from "./controls/ReceptionContactEditor.vue";
import ReceptionDeliveryEditor from "./controls/ReceptionDeliveryEditor.vue";
import CommonReceptionDetailEditor from "./controls/CommonReceptionDetailEditor.vue";
import ReceptionDetailEditor from "./controls/ReceptionDetailEditor.vue";
import ReceptionPatientEditor from "./controls/ReceptionPatientEditor.vue";
import ReceptionInformationEditor from "./controls/ReceptionInformationEditor.vue";
import ReceptionRecipientEditor from "./controls/ReceptionRecipientEditor.vue";
import { User } from "../../../domain/user";
import { DomainRegistry } from "../../../domain";
import { Department } from "../../../domain/department";
import { UnmanagedDocumentSummaryInformation } from "../../../domain/document";
import Enumerable from "linq";


@Component({
  components: {
    ReceptionApplicantEditor,
    ReceptionContactEditor,
    ReceptionDeliveryEditor,
    CommonReceptionDetailEditor,
    ReceptionDetailEditor,
    ReceptionPatientEditor,
    ReceptionInformationEditor,
    ReceptionRecipientEditor,

    ProjectTeamListSelectorDialog,
    DepartmentListSelectorDialog,
    HospitalizationHistorySelectorDialog,
    VisitHistorySelectorDialog,
    RoutePatternSelectorDialog,
    HisInfoListSelectDialog,
    CommentDialog,
  }
})
export default class WorkflowEditor extends Mixins(ModelEditableMixin, FormatValidatableMixin) {
  // ModelEditableMixinに実体あり
  editingSource: ReceptionEditor;

  @Prop({ default: false })
  isUnmanaged: boolean;

  @Prop({ default: null })
  unmanagedDocumentSummaryInformations: UnmanagedDocumentSummaryInformation[];

  @Prop()
  allUser: User[];

  @Prop()
  isQuoted: boolean;

  @Prop({ default: false })
  isCommentConflicted: boolean;

  @Prop({ default: false })
  isNextMessageConflicted: boolean;

  @Prop({ default: false })
  isRestrictCommentConflicted: boolean;

  @Prop()
  patientNo: string;

  @Emit()
  conflictResolved(kind: ReceptionCommentKinds, confirmedComment: ReceptionComment): void {}

  data(): any {
    return {
      projectTeamSelectDialog: null,
      multiUserSelectDialog: null,
      hospitalizationHistorySelectDialog: null,
      visitHistorySelectDialog: null,
      hospitalizationSelectDialog: null,
      diseaseSelectDialog: null,
      routePatternSelectDialog: null,
      commentDialog: null,
      hisParameter: null,
      diseaseHisParameter: null,
      allValidUsers: [],
      allDepartments: [],
      workflowRoutes: [],
    };
  }
  projectTeamSelectDialog: ProjectTeamListSelectorDialog;
  hospitalizationHistorySelectDialog: HospitalizationHistorySelectorDialog;
  visitHistorySelectDialog: VisitHistorySelectorDialog;
  hospitalizationSelectDialog: HisInfoListSelectDialog;
  diseaseSelectDialog: HisInfoListSelectDialog;
  routePatternSelectDialog: RoutePatternSelectorDialog;
  commentDialog: CommentDialog;
  hisParameter: HisItemParameter;
  diseaseHisParameter: HisItemParameter;
  allValidUsers: User[];
  allDepartments: Department[];
  workflowRoutes: WorkflowRouteEditorModel[];

  created(): void {
    this.hisParameter = new HisItemParameter();
    this.hisParameter.informationKind = InformationKinds.Hospitalization;
    this.hisParameter.isMultiSelect = false;
    this.diseaseHisParameter = new HisItemParameter();
    this.diseaseHisParameter.informationKind = InformationKinds.Disease;
    this.diseaseHisParameter.isMultiSelect = false;
    this.updateValidAllUsers();
    this.updateValidDepartments();
    this.updateWorkflowRoutes();
  }

  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.projectTeamSelectDialog = this.$refs.projectTeamSelectDialog as ProjectTeamListSelectorDialog;
    this.hospitalizationHistorySelectDialog = this.$refs.hospitalizationHistorySelectDialog as HospitalizationHistorySelectorDialog;
    this.visitHistorySelectDialog = this.$refs.visitHistorySelectDialog as VisitHistorySelectorDialog;
    this.hospitalizationSelectDialog = this.$refs.hisInfoListSelectDialog as HisInfoListSelectDialog;
    this.diseaseSelectDialog = this.$refs.diseaseSelectDialog as HisInfoListSelectDialog;
    this.routePatternSelectDialog = this.$refs.routePatternSelectDialog as RoutePatternSelectorDialog;
    this.commentDialog = this.$refs.commentDialog as CommentDialog;
  }

  // 表示制御用----------

  get mode(): ReceptionEditKinds {
    return this.editingSource.mode;
  }

  get isRegistered(): boolean {
    return this.mode === ReceptionEditKinds.Edit;
  }

  get isReceptionDetailAddible(): boolean {
    const maxCount = this.editingSource.displayInfo.receptionDetailMaxCount;
    return !this.isRegistered && ((maxCount < 1) || (this.details.length < maxCount));
  }

  get isSingleInputNeeded(): boolean {
    return this.editingSource.displayInfo.inputUnitSetting.isSingleInputNeeded;
  }

  get inputSectionItems(): ReceptionInputSection[] {
    return this.editingSource.displayInfo.inputSectionList;
  }

  get relationshipItems(): ReceptionTypeItem[] {
    return this.editingSource.displayInfo.relationshipList;
  }

  get paperNameItems(): ReceptionTypeItem[] {
    return this.editingSource.displayInfo.paperNameList;
  }

  get paymentStatusItems(): ReceptionTypeItem[] {
    return this.editingSource.displayInfo.paymentStatusList;
  }

  get shouldShowManagerPhoneNumber(): boolean {
    return this.editingSource.displayInfo.shouldShowManagerPhoneNumber;
  }

  get labelSetting(): ReceptionDispInfo {
    return this.editingSource.displayInfo.labelSetting;
  }

  get commentLabel(): string {
    return this.editingSource.displayInfo.labelSetting.commentLabelName;
  }

  get restrictCommentLabel(): string {
    return this.editingSource.displayInfo.labelSetting.restrictCommentLabelName;
  }

  get nextMessageLabel(): string {
    return this.editingSource.displayInfo.labelSetting.nextMessageLabelName;
  }

  get generalFlag1Label(): string {
    return this.editingSource.displayInfo.labelSetting.generalFlag1LabelName;
  }

  get isGeneralFlag1Enable(): boolean {
    return this.editingSource.displayInfo.labelSetting.isGeneralFlag1Visible;
  }

  get isInOutTypeEnable(): boolean {
    return this.editingSource.displayInfo.labelSetting.isInOutTypeVisible;
  }

  get isApplicantVisible(): boolean {
    return this.editingSource.displayInfo.labelSetting.isApplicantVisible;
  }

  get isRecipientVisible(): boolean {
    return this.editingSource.displayInfo.labelSetting.isRecipientVisible;
  }

  get isContactVisible(): boolean {
    return this.editingSource.displayInfo.labelSetting.isContactVisible;
  }

  get isAddressTypeEnable(): boolean {
    return this.editingSource.displayInfo.labelSetting.isAddressTypeVisible;
  }

  get isCommentEnable(): boolean {
    return !this.isCommentInputSingle;
  }

  get hasEditCommentPermission(): boolean {
    return this.editingSource.displayInfo.isCommentEditable;
  }

  get isCommentInputSingle(): boolean {
    return this.editingSource.displayInfo.inputUnitSetting.isCommentInputSingle;
  }

  get isNextMessageInputSingle(): boolean {
    return this.editingSource.displayInfo.inputUnitSetting.isNextMessageInputSingle;
  }

  get commentUnitKind(): ReceptionCommentUnitKinds {
    return this.editingSource.displayInfo.commentMode;
  }

  get nextMessageUnitKind(): ReceptionCommentUnitKinds {
    return this.editingSource.displayInfo.nextMessageMode;
  }

  get restrictCommentUnitKind(): ReceptionCommentUnitKinds {
    return this.editingSource.displayInfo.restrictCommentMode;
  }

  get commentDefaultSortType(): ReceptionCommentSortItemKinds {
    return this.editingSource.displayInfo.commentDefaultSortType;
  }

  get isCommentRegisterable(): boolean {
    return this.editingSource.displayInfo.isCommentRegisterable;
  }

  get isNextMessageRegisterable(): boolean {
    return this.editingSource.displayInfo.isNextMessageRegisterable;
  }

  get isRestrictCommentRegisterable(): boolean {
    return this.editingSource.displayInfo.isRestrictCommentRegisterable;
  }

  get isRestrictCommentEnable(): boolean {
    return this.editingSource.displayInfo.isRestrictCommentEnable;
  }

  get hasEditRestrictCommentPermission(): boolean {
    return this.editingSource.displayInfo.isRestrictCommentEditable;
  }

  get isNextMessageEnable(): boolean {
    return !this.isNextMessageInputSingle;
  }

  get hasEditNextMessagePermission(): boolean {
    return this.editingSource.displayInfo.isNextMessageEditable;
  }

  get isProjectTeamEnable(): boolean {
    // TODO: プロジェクトチームの入力単位・連動機能の検討
    return this.isProjectTeamVisible;
  }

  get isProjectTeamVisible(): boolean {
    return this.editingSource.displayInfo.labelSetting.isProjectTeamVisible;
  }

  get shouldAutoApplyProjectTeamInfo(): boolean {
    return this.editingSource.displayInfo.shouldAutoApplyProjectTeamInfo;
  }

  get isDepartmentEnable(): boolean {
    return !this.isDepartmentInputSingle;
  }

  get isDepartmentInputSingle(): boolean {
    return this.editingSource.displayInfo.inputUnitSetting.isDepartmentInputSingle;
  }

  get isManagerEnable(): boolean {
    return !this.isManagerInputSingle;
  }

  get isManagerInputSingle(): boolean {
    return this.editingSource.displayInfo.inputUnitSetting.isManagerInputSingle;
  }

  get isPhaseEnable(): boolean {
    return !this.isPhaseInputSingle;
  }

  get isPhaseInputSingle(): boolean {
    return this.editingSource.displayInfo.inputUnitSetting.isPhaseInputSingle;
  }

  get shouldSelectManagers(): boolean {
    return this.editingSource.displayInfo.shouldSelectManagers;
  }

  get proofPeriodDefaultCount(): number {
    return this.editingSource.displayInfo.proofPeriodDefaultCount;
  }

  get proofPeriodMaxCount(): number {
    return this.editingSource.displayInfo.proofPeriodMaxCount;
  }

  get deliveryKindList(): ReceptionDeliveryKind[] {
    return this.editingSource.displayInfo.deliveryKindList;
  }

  get displayProgressConditionKinds(): ProgressConditionKinds[] {
    return this.editingSource.displayInfo.displayProgressConditions;
  }

  get defaultProgressCondition(): ProgressConditionKinds {
    return this.editingSource.displayInfo.defaultProgressCondition;
  }

  get defaultDeliveryTypeCode(): number {
    return this.editingSource.displayInfo.defaultDeliveryTypeCode;
  }

  get isHospitalizationHistoryEnable(): boolean {
    return this.editingSource.displayInfo.isHospitalizationHistoryEnable;
  }

  get isVisitHistoryEnable(): boolean {
    return this.editingSource.displayInfo.isVisitHistoryEnable;
  }

  get isFormatSelectorAllTabEnable(): boolean {
    return this.editingSource.displayInfo.isFormatSelectorAllTabEnable;
  }

  get isPaperEnable(): boolean {
    return this.editingSource.displayInfo.isPaperEnable;
  }

  get isPaperNameEnable(): boolean {
    return this.editingSource.displayInfo.isPaperNameEnable;
  }

  get isPaperCompanyNameEnable(): boolean {
    return this.editingSource.displayInfo.isPaperCompanyNameEnable;
  }

  get contactNameItems(): ReceptionTypeItem[] {
    return this.editingSource.displayInfo.contactNameList;
  }

  get isWorkflowPhasesQuoteEnable(): boolean {
    return this.editingSource.displayInfo.isWorkflowPhasesQuoteEnable;
  }

  get isCommentEditableSingleUnitOnly(): boolean {
    return this.editingSource.displayInfo.isCommentEditableSingleUnitOnly;
  }

  get shouldSortCommentAsc(): boolean {
    return this.editingSource.displayInfo.shouldSortCommentAsc;
  }

  get isDiseaseVisible(): boolean {
    return this.editingSource.displayInfo.labelSetting.isDiseaseVisible;
  }

  get hasNewPhoneNumber(): boolean {
    const phoneNumber = this.applicant.phoneNumber ? this.applicant.phoneNumber : "";
    const patientInfoPhoneNumber = (this.patientInfo.address && this.patientInfo.address.phoneNumber) ? this.patientInfo.address.phoneNumber : "";
    return phoneNumber !== patientInfoPhoneNumber;
  }

  get hasNewZipCode(): boolean {
    const zipCode = this.applicant.zipCode ? this.applicant.zipCode : "";
    const patientInfoZipCode = (this.patientInfo.address && this.patientInfo.address.zipCode) ? this.patientInfo.address.zipCode : "";
    return zipCode !== patientInfoZipCode;
  }

  get hasNewAddress(): boolean {
    const address = this.applicant.address ? this.applicant.address : "";
    const patientInfoAddress = (this.patientInfo.address && this.patientInfo.address.address) ? this.patientInfo.address.address : "";
    return address !== patientInfoAddress;
  }

  // ----------------------
  get isPatientFixed(): boolean {
    return !!this.reception.id || !!this.editingSource.sourceReceptionId || !!this.editingSource.sourceReceptionDetailId;
  }

  get patientInfo(): ReceptionPatient {
    return this.editingSource.reception.patientInfo;
  }

  set patientInfo(value: ReceptionPatient) {
    this.writeProperty((r: ReceptionEditor) => (r.reception.patientInfo = value));

  }

  @Watch("patientInfo")
  onPatientInfoChanged(newValue: ReceptionPatient, oldValue: ReceptionPatient) {

    if (!newValue || !newValue.patient) { return; }
    if (oldValue && oldValue.patient && newValue.patient.id === oldValue.patient.id) { return; }

    console.log("called patientInfo change.");
    // 申請者情報も自動セット＋交付先情報をクリアする
    this.setNewApplicantFromPatientAndClearDelivery();
  }

  get isPatientSelected(): boolean {
    return !!this.reception.patientInfo.patient;
  }

  get hisInformation(): HisInformation {
    return this.isPatientSelected ? this.reception.patientInfo.hisInformation 
      : new HisInformation([],
        new Table([], []),
        new Table([], []),
        new Table([], []),
        [],
        [],
        [],
        null,
        null);
  }

  get hasDiseaseData(): boolean {
    return this.hisInformation ? this.hisInformation.diseaseCollection.rows.length > 0 : false;
  }

  get hasHospitalizationData(): boolean {
    return this.hisInformation ? this.hisInformation.hospitalizationCollection.rows.length > 0 : false;
  }

  get hasHospitalizationHistoryData(): boolean {
    return this.hisInformation && this.hisInformation.hospitalizationHistories.length > 0;
  }

  get hasVisitHistoryData(): boolean {
    return this.hisInformation && this.hisInformation.visitHistories.length > 0;
  }

  get hasSelectableRoutePattern(): boolean {
    return this.workflowRoutes && this.workflowRoutes.length > 0;
  }

  get reception(): Reception {
    return this.editingSource.reception;
  }

  set reception(value: Reception) {
    this.writeProperty((r: ReceptionEditor) => (r.reception = value));
  }

  get commonDetail(): ReceptionDetail {
    return this.editingSource.commonReceptionDetail;
  }

  set commonDetail(value: ReceptionDetail) {
    this.writeProperty((r: ReceptionEditor) => (r.commonReceptionDetail = value));
  }

  get commonDetailDepartment(): Department {
    return this.editingSource.commonReceptionDetail.department;
  }

  // 更新はupdateDetailで頑張る
  get details(): ReceptionDetail[] {
    return this.editingSource.receptionDetails;
  }

  updateDetail(index: number, detail: ReceptionDetail) {
    // すでにclone()されているインスタンスが投げられているはずなので、ここではclone()しない
    this.editingSource.receptionDetails.splice(index, 1, detail);
  }

  addDetail(): void {
    // VueのBindingの仕様の関係で、要素の追加・削除には注意が必要
    // とりあえずはspliceを使って操作すれば何とかなる
    const detail = new ReceptionDetail(this.proofPeriodDefaultCount);
    detail.route.progressCondition = this.defaultProgressCondition;
    this.editingSource.receptionDetails.splice(
      this.editingSource.receptionDetails.length,
      0,
      detail
    );
  }

  removeDetail(index: number): void {
    // VueのBindingの仕様の関係で、要素の追加・削除には注意が必要
    // とりあえずはspliceを使って操作すれば何とかなる
    this.editingSource.receptionDetails.splice(index, 1);
  }

  copyDetail(index: number, detail: ReceptionDetail): void {
    // VueのBindingの仕様の関係で、要素の追加・削除には注意が必要
    // とりあえずはspliceを使って操作すれば何とかなる
    const cloned = detail.copy();
    this.editingSource.receptionDetails.splice(this.editingSource.receptionDetails.length, 0, cloned); // 末尾に追加
  }

  updateCommonDetail(detail: ReceptionDetail) {
    // すでにclone()されているインスタンスが投げられているはずなので、ここではclone()しない
    this.commonDetail = detail;
  }

  get recipient(): ReceptionRecipient {
    return this.editingSource.reception.recipient;
  }

  set recipient(value: ReceptionRecipient) {
    this.writeProperty((r: ReceptionEditor) => (r.reception.recipient = value));
  }

  get applicant(): ReceptionApplicant {
    return this.editingSource.reception.applicant;
  }

  set applicant(value: ReceptionApplicant) {
    this.writeProperty((r: ReceptionEditor) => (r.reception.applicant = value));
  }

  get contact(): ReceptionContact {
    return this.editingSource.reception.contact;
  }

  set contact(value: ReceptionContact) {
    this.writeProperty((r: ReceptionEditor) => (r.reception.contact = value));
  }

  get delivery(): ReceptionDelivery {
    return this.editingSource.reception.delivery;
  }

  set delivery(value: ReceptionDelivery) {
    this.writeProperty((r: ReceptionEditor) => (r.reception.delivery = value));
  }

  // 本人ボタン押下（受取者）
  setRecipientFromPatient(): void {
    const recipient = this.createRecipientFromSelectedPatient();
    this.writeProperty((r: ReceptionEditor) => (r.reception.recipient = recipient));
  }

  createRecipientFromSelectedPatient(): ReceptionRecipient {
    const cloned = this.recipient.clone();
    cloned.relationship = "本人";
    cloned.name = this.patientInfo.patient.name;
    return cloned;
  }

  // 本人ボタン押下（申請者）
  setApplicantFromPatient(): void {
    const applicant = this.createApplicantFromSelectedPatient();
    this.writeProperty((r: ReceptionEditor) => (r.reception.applicant = applicant));
  }

  /**
   * 患者を変更する場合、変更前の住所などの入力は残っていて欲しくない
   * （受付・依頼引用後に患者を変更するケースなど）
   * ばらばらにwritePropertyすると正常に更新されないので、一回のwritePropertyでまとめて更新する
   */
  private setNewApplicantFromPatientAndClearDelivery() {
    // createApplicantFromSelectedPatientだとメールアドレス・携帯電話番号が引き継がれているのでここでは使用していない
    const defaultDeliveryType = this.getDefaultDeliveryType();
    const applicant = this.createNewApplicantFromSelectedPatient();
    this.writeProperty((r: ReceptionEditor) => {
      r.reception.applicant = applicant;
      r.reception.delivery = new ReceptionDelivery();
      if (!!defaultDeliveryType) {
        r.reception.delivery.type = defaultDeliveryType.clone();
      }
    });
  }

  getDefaultDeliveryType(): ReceptionDeliveryKind {
    if (this.defaultDeliveryTypeCode == null || !this.deliveryKindList) { return null; }
    return Enumerable.from(this.deliveryKindList)
      .firstOrDefault(d => d.code === this.defaultDeliveryTypeCode && d.isEnable);
  }

  createApplicantFromSelectedPatient(): ReceptionApplicant {
    const cloned = this.applicant.clone();
    cloned.relationship = "本人";
    cloned.name = this.patientInfo.patient.name;
    if (this.patientInfo.address) {
      cloned.phoneNumber = this.patientInfo.address.phoneNumber;
      cloned.zipCode = this.patientInfo.address.zipCode;
      cloned.address = this.patientInfo.address.address;
    }

    return cloned;
  }

  private createNewApplicantFromSelectedPatient(): ReceptionApplicant {
    const applicant = new ReceptionApplicant();
    applicant.relationship = "本人";
    applicant.name = this.patientInfo.patient.name;
    if (this.patientInfo.address) {
      applicant.phoneNumber = this.patientInfo.address.phoneNumber;
      applicant.zipCode = this.patientInfo.address.zipCode;
      applicant.address = this.patientInfo.address.address;
    }

    return applicant;
  }

  // 本人ボタン押下（交付先）
  setDeliveryFromPatient(): void {
    if (!this.patientInfo.address) { return; }
    const delivery = this.createDeliveryFromSelectedPatient();
    this.writeProperty((r: ReceptionEditor) => (r.reception.delivery = delivery));
  }

  createDeliveryFromSelectedPatient(): ReceptionDelivery {
    const cloned = this.delivery.clone();
    cloned.zipCode = this.patientInfo.address.zipCode;
    cloned.address = this.patientInfo.address.address;
    return cloned;
  }

  async validateSelectedFormat(format: any): Promise<boolean> {
    return this.validateFormat(format, true);
  }

  get nondisplayDepartmentCodes(): string[] {
    return this.editingSource.displayInfo.nondisplayDepartmentCodeList;
  }

  updateValidAllUsers(): void {
    const repository = DomainRegistry.user.getUserRepository();
    repository.getAllEntities()
      .then(e => this.allValidUsers = e)
      .catch(e => {
        this.$error(
          "職員情報取得失敗",
          "職員情報を取得できませんでした。",
          e,
        );
      });
  }

  updateValidDepartments(): void {
    const repository = DomainRegistry.department.getDepartmentRepository();
    repository.getAllEntities()
      .then(e => this.allDepartments = e)
      .catch(e => {
        this.$error(
          this.$wording.common.department + "情報取得失敗",
          this.$wording.common.department + "情報を取得できませんでした。",
          e,
        );
      });
  }

  updateDeitalsLimitDate(diffDays: number): void {
    const editors = this.$refs.receptionDetailEditors as ReceptionDetailEditor[];
    if (!editors) { return; }
    Enumerable.from(editors).forEach(e => {
      e.updatePhaseDate(0, diffDays);
    });

    const commonEditor = this.$refs.commonReceptionDetailEditor as CommonReceptionDetailEditor;
    if (this.isPhaseInputSingle && commonEditor) {
      commonEditor.updatePhaseDate(0, diffDays);
    }
  }

  updateWorkflowRoutes(): void {
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    repository.getSelectableRoutePatterns()
      .then(r => this.workflowRoutes = r)
      .catch(e => {
        this.$error(
          "パターン情報取得失敗",
          "パターン情報を取得できませんでした。",
          e,
        );
      });
  }
}
